import { render } from "./purchases_check.vue?vue&type=template&id=a0061ed4&scoped=true"
import script from "./purchases_check.vue?vue&type=script&lang=js"
export * from "./purchases_check.vue?vue&type=script&lang=js"

import "./purchases_check.vue?vue&type=style&index=0&id=a0061ed4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0061ed4"]])

export default __exports__